module.exports = __webpack_public_path__ + "img/resource_pkg1.9ff1aea8.png";